<script>
import { get } from "lodash";
import { mapState } from "vuex";
import api from "@/services/api";

const MESSAGE_BY_STATUS = {
  200: "Obrigado por responder o e-mail e nos ajudar!",
  404: "Não encontramos a indicação que você está procurando.",
  406: "Sua indicação já foi confirmada.",
  409: "Você já sugeriu essa indicação.",
}

export default {
  name: "alert-unsubscribe",
  data: () => ({
    params: null,
    message: "Olá, estamos processando sua solicitação.",
  }),
  methods: {
    async fetchUnsubscribe() {
      try {
        this.$vs.loading();

        const params = get(this.$router, "history.current.params", null);

        if (params.uuid !== null) {
          //alert('UUID: ' + params.uuid);
          // TODO: Call API to unsubscribe
          const response = await api.put(`api/v1/alerts/unsubscribe/${params.uuid}`);
          //const response = await api.get(`api/healt-check`);
        }

      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }  
    }
  },
  created() {
    this.fetchUnsubscribe();
  },
};
</script>

<template style="display: flex;">
  <div class="align" style="width: 100%; height: 100%;">
    <div class="main-content">
      <div class="confirmation">
        <lottie-player
          src="/cancel-animation.json"
          background="transparent"
          speed="1"
          style="width: auto; max-height: 180px; margin: 0 0 0;"
          autoplay
          :loop="false"
          >
        </lottie-player>
      </div>
      <section class="main-section" style="margin-top: -30px;">
        <header>
          <h1 class="main-title">Envio de vagas por e-mail desativado</h1>
        </header>
        <p class="main-text">Você não receberá mais vagas no seu e-mail, mas ainda poderá acessar<br> sua área de candidatos a qualquer momento para se candidatar às<br> oportunidades disponíveis e/ou reativar o envio de vagas por e-mail</p>
        <div class="main-buttons">
          <router-link :to="`/alerts/subscribe/${this.$router.history.current.params.uuid}`" class="btn btn-active-alert">Ativar o envio de vagas</router-link>
          <router-link to="/recrutei-empregos/login" class="btn btn-candidate-area">Área do candidato</router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .align {
    position:absolute;
    display: flex;
    width: 100%;
    height: 100%;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 100%;
    vertical-align: middle;
    min-width: 100%;

    .main-title {
      font-size: 20px;
      font-weight: 700;
      color: #333;
    }

    .main-text {
      font-size: 16px;
      color: #666;
      line-height: 18px;

      display: block;
      margin-bottom: 5px;
    }

    .main-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 25px;
      width: 100%;
      vertical-align: middle;

      max-width: 600px;
    }

    .main-buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 20px;

      .btn-active-alert {
        color: #4f4f4f;
        background: #fff;
        border: 1px solid #A8A8A8;
        padding: 12px 32px;
        font-size: 16px;
        font-weight:400;
        letter-spacing: -0.05rem;
        border-radius: 8px;
        line-height: 20px;

        &:hover {
          color: #fff;
          background: #1C86EE;
          border: 1px solid #1C86EE;
        }
      }

      .btn-candidate-area {
        color: #fff;
        background: #1C86EE;
        border: 1px solid #1C86EE;
        padding: 12px 32px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: -0.05rem;
        border-radius: 8px;
        line-height: 20px;

        &:hover {
          color: #4f4f4f;
          background: #fff;
          border: 1px solid #A8A8A8;
        }
      }
    }
  }

.confirmation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
  width: 100%;

  img {
    width: 350px;
    object-fit: contain;
  }
}
</style>
